import { optionSchema } from '@/common/schemas/option.schema'
import { unFormatUnit } from '@/common/utils/unFormatters'
import { z } from 'zod'

export const equipmentCategorySchema = z.object({
  display_name: z
    .string({ message: 'Tamanho mínimo: 3 caracteres' })
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' })
    .max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  description: z
    .string({ message: 'Tamanho mínimo: 3 caracteres' })
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' })
    .max(256, { message: 'Tamanho máximo: 256 caracteres' }),
  equipment_tier: optionSchema.optional().nullable(),
  max_tank_capacity: z
    .string({ message: 'Capacidade máxima do tanque deve ser maior que 0' })
    .refine(
      (value) => {
        return unFormatUnit(value, 'L') > 0
      },
      { message: 'Capacidade máxima do tanque deve ser maior que 0' },
    )
    .refine(
      (value) => {
        return unFormatUnit(value, 'L') <= 99_999
      },
      { message: 'Capacidade máxima do tanque deve ser menor ou igual a 99.999' },
    ),
  bypass_consumption_usage_validations: z.boolean().optional().nullable(),
  driver_license_category_equipment_categories: z.array(optionSchema).optional().nullable(),
})

export type EquipmentCategoryValidationSchema = z.infer<typeof equipmentCategorySchema>
